import { render, staticRenderFns } from "./OptionCircle.vue?vue&type=template&id=08c93a91&scoped=true"
import script from "./OptionCircle.vue?vue&type=script&lang=js"
export * from "./OptionCircle.vue?vue&type=script&lang=js"
import style0 from "./OptionCircle.vue?vue&type=style&index=0&id=08c93a91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c93a91",
  null
  
)

export default component.exports